var storage={
    // baseUrl:" ",
    // baseUrl:"http://gufennew.shanxiangjiaoyu.com",
    // "proxy": "http://192.168.0.148:8080",  
    // "proxy": "https://gufen.shanxiangjiaoyu.com",
    // baseUrl:"http://47.92.69.244:8087",
    // baseUrl:"http://gufen-beta.shanxiangjiaoyu.com",
    baseUrl:"https://gufen.shanxiangjiaoyu.com",
    set(key,value){
sessionStorage.setItem(key,JSON.stringify(value));
    },
    get(key)
    {
       return JSON.parse(sessionStorage.getItem(key));  
    },
    remove(key){
        sessionStorage.removeItem(key);
    }
}
export default storage;     